/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/178-road': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M11 16h5L12 0H9l.5 4h-3L7 0H4L0 16h5l.5-4h5l.5 4zm-5.25-6l.5-4h3.5l.5 4h-4.5z"/>'
  }
})
